/**
 * Daisi Backend API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

// @ts-ignore
import { ReleaseNoteDto } from '../model/release-note-dto';
import { Param } from '../param';
import { ApiConfigurationService } from '../../helpers/api-configuration.service';
import { HttpParamHelper } from '../../helpers/http-param-helper';
import { CustomHttpParameterCodec } from '../encoder';

import { COLLECTION_FORMATS } from '../variables';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNoteControllerService {
  private readonly encoder: CustomHttpParameterCodec;
  private readonly httpClient = inject(HttpClient);
  protected readonly configuration = inject(ApiConfigurationService);

  constructor() {
    this.encoder = this.configuration.encoder;
  }

  public _delete(
    id: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public _delete(
    id: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public _delete(
    id: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public _delete(
    id: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling _delete.');
    }
    return this.httpClient.request<any>(
      'delete',
      `/api/release-notes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      {
        observe: observe,
      },
    );
  }

  public findAll(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<ReleaseNoteDto>>;
  public findAll(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<ReleaseNoteDto>>>;
  public findAll(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<ReleaseNoteDto>>>;
  public findAll(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    return this.httpClient.request<Array<ReleaseNoteDto>>('get', `/api/release-notes`, {
      responseType: '*/*'.startsWith('text/') ? ('text' as 'json') : undefined,
      observe: observe,
    });
  }

  public findPublished(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<ReleaseNoteDto>>;
  public findPublished(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<ReleaseNoteDto>>>;
  public findPublished(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<ReleaseNoteDto>>>;
  public findPublished(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    return this.httpClient.request<Array<ReleaseNoteDto>>('get', `/api/release-notes/published`, {
      responseType: '*/*'.startsWith('text/') ? ('text' as 'json') : undefined,
      observe: observe,
    });
  }

  public get(
    id: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ReleaseNoteDto>;
  public get(
    id: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ReleaseNoteDto>>;
  public get(
    id: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ReleaseNoteDto>>;
  public get(
    id: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling get.');
    }
    return this.httpClient.request<ReleaseNoteDto>(
      'get',
      `/api/release-notes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      {
        responseType: '*/*'.startsWith('text/') ? ('text' as 'json') : undefined,
        observe: observe,
      },
    );
  }

  public markAsRead(
    requestBody: Array<string>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public markAsRead(
    requestBody: Array<string>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public markAsRead(
    requestBody: Array<string>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public markAsRead(
    requestBody: Array<string>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (requestBody === null || requestBody === undefined) {
      throw new Error(
        'Required parameter requestBody was null or undefined when calling markAsRead.',
      );
    }
    return this.httpClient.request<any>('put', `/api/release-notes/markAsRead`, {
      body: requestBody,
      observe: observe,
    });
  }

  public save(
    releaseNoteDto: ReleaseNoteDto,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ReleaseNoteDto>;
  public save(
    releaseNoteDto: ReleaseNoteDto,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ReleaseNoteDto>>;
  public save(
    releaseNoteDto: ReleaseNoteDto,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ReleaseNoteDto>>;
  public save(
    releaseNoteDto: ReleaseNoteDto,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (releaseNoteDto === null || releaseNoteDto === undefined) {
      throw new Error('Required parameter releaseNoteDto was null or undefined when calling save.');
    }
    return this.httpClient.request<ReleaseNoteDto>('post', `/api/release-notes`, {
      body: releaseNoteDto,
      responseType: '*/*'.startsWith('text/') ? ('text' as 'json') : undefined,
      observe: observe,
    });
  }

  public unread(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<ReleaseNoteDto>>;
  public unread(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<ReleaseNoteDto>>>;
  public unread(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<ReleaseNoteDto>>>;
  public unread(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    return this.httpClient.request<Array<ReleaseNoteDto>>('get', `/api/release-notes/unread`, {
      responseType: '*/*'.startsWith('text/') ? ('text' as 'json') : undefined,
      observe: observe,
    });
  }
}
